import React from 'react'

import bemit from '@function/bemit'

const config =
[
	{ label: '', value: 'cb' },
	{ label: 'Nom Prénom', value: 'name' },
	{ label: 'Statut', value: 'status' },
	{ label: 'Attribué', value: 'attributed' },
	{ label: 'Utilisé', value: 'used' },
	{ label: 'Restant', value: 'value' },
	{ label: 'Catalogue utilisé', value: 'catalog_used' },
];

export default function UsersAbondementsHeader ({ ...props })
{
	const cells = config.map(function ({ label, value })
	{
		return (
			<div className={ 'c-user-abondement-row__cell UserAbondement-' + value }
				key={ value }>
				{ label }
			</div>
		);
	});

	return (
		<div className={ bemit('c-user-abondement-row', ['header']) }>

			{ cells }
			
		</div>
	);
}